import React from 'react';
import style from './avatarProfile.module.css';
import defaultPhoto from '../../../../../../../assets/imgs/user.jpeg';

const AvatarProfile = (props) => {
    return (
        <div className={style.avatarContainer}>
                <img src={props.photo
                    ? props.photo
                    : defaultPhoto} alt="user" />
                {(props.userId === props.authId)
                    && <input type="file" onChange={props.fileChangeHandler} />}
                {props.error && <i>{props.error}</i>}
            </div>
    )
}

export default AvatarProfile;